import data from './../data/resume.json';
const GET_RESUME = 'GET_RESUME';

const getResume = () => ({
	type: GET_RESUME,
	data,
});

export {
	getResume,
};